import { useSelector } from 'react-redux';
import { useContext } from 'react';
import { ManageCampaignsContext } from 'contexts';

export const useFacade = (selectedDate) => {
  const campaignChanges = useSelector((state) => state.manageCampaigns.dataChangesLog);
  const isChangesError = useSelector((state) => state.manageCampaigns.dataChangesLogError);
  const isNotesError = useSelector((state) => state?.manageCampaigns?.dataChartEventsError);

  // get relevant campaigns from the table
  const { rowData } = useContext(ManageCampaignsContext);

  // filter changes for a specific day
  const dayChanges = campaignChanges?.filter((campaign) => {
    return campaign.changes.some((change) => {
      const changeDate = new Date(change.event_date);
      return areDatesEqual(changeDate, selectedDate);
    });
  });

  // filter campaigns that are shown on the table
  const filteredChahges = dayChanges.filter((change) => {
    return rowData.some((item) => item._campaignid === +change.cm_campaignid);
  });

  return {
    campaignChanges: filteredChahges || [],
    isChangesError,
    isNotesError,
  };
};

function areDatesEqual(date1, date2) {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}
